/**
 * @generated SignedSource<<118fc3a237881da0519b8c4cc852d8c2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type issueSearch_issueNavigator$data = {
  readonly viewConfigSettings?: {
    readonly isHierarchyEnabled: boolean | null | undefined;
  } | null | undefined;
  readonly viewId: string;
  readonly " $fragmentType": "issueSearch_issueNavigator";
};
export type issueSearch_issueNavigator$key = {
  readonly " $data"?: issueSearch_issueNavigator$data;
  readonly " $fragmentSpreads": FragmentRefs<"issueSearch_issueNavigator">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2apiupdatesrelayprovider"
    },
    {
      "kind": "RootArgument",
      "name": "staticViewInput"
    }
  ],
  "kind": "Fragment",
  "name": "issueSearch_issueNavigator",
  "selections": [
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2apiupdatesrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": [
            {
              "kind": "Variable",
              "name": "staticViewInput",
              "variableName": "staticViewInput"
            }
          ],
          "concreteType": "JiraIssueSearchViewConfigSettings",
          "kind": "LinkedField",
          "name": "viewConfigSettings",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "isHierarchyEnabled"
            }
          ]
        }
      ]
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "viewId"
      },
      "action": "THROW",
      "path": "viewId"
    }
  ],
  "type": "JiraIssueSearchView"
};

(node as any).hash = "90664ed4e279039c63da57e40da847c6";

export default node;
